// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__KzmDo","subheader":"ReorderModal_subheader__2hfqO","listWrap":"ReorderModal_listWrap__1Y4FO"};